<template>
  <v-sheet
    id="dropzone"
    ref="dzone"
    tabindex="0"
    title="Click to grap a file from your PC!"
    color="indigo lighten-4"
    width="100%"
    style="cursor:pointer;"
    height="200"
    class="pa-2"
  >
    <input
      id="fileUpload"
      ref="upload"
      type="file"
      accept="text/xml"
      style="display:none"
    />
    <v-row justify="center">
      <v-icon
        v-if="!dragover"
        color="indigo darken-2"
        size="75"
      >
        mdi-cloud-upload-outline</v-icon>
      <v-icon
        v-if="dragover"
        color="indigo darken-2"
        size="75"
      >
        mdi-book-plus
      </v-icon>
    </v-row>
    <v-row justify="center">
      <span class="text-h6 indigo--text text--darken-2">
        Drag'n drop or click to upload file!
      </span>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'FileDropZone',

  components: {},

  data: function () {
    return {
      formUpload: false,
      dragover: false
    }
  },

  mounted: function () {
    const dropzone = this.$el
    const fileupload = this.$el.firstElementChild

    if (dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener('dragenter', (e) => {
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener('dragleave', (e) => {
        e.preventDefault()
        this.dragover = false
      })
      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener('drop', (e) => {
        e.preventDefault()
        const dragevent = e
        if (dragevent.dataTransfer) {
          this.filesSelected(dragevent.dataTransfer.files)
        }
      })

      // register event listener for keyboard usage
      dropzone.addEventListener('click', (e) => {
        e.preventDefault()
        if (fileupload) {
          fileupload.click()
        }
      })
      dropzone.addEventListener('keypress', (e) => {
        e.preventDefault()
        const keyEvent = e
        if (keyEvent.key === 'Enter') {
          if (fileupload) fileupload.click()
        }
      })

      // register listeners on the file input
      if (fileupload) {
        fileupload.addEventListener('change', (e) => {
          const target = e.target
          if (target.files) {
            this.filesSelected(target.files)
          }
        })
      }
    }
  },

  methods: {
    filesSelected(_) {
      this.dragover = false
    }
  }
}
</script>
